export default {
    TITLE:'Edit details or reupload',
    SUBTITLE:'Edit {{type}} details',
    TOOLTIP:'Use a double page scan of the passport clearly showing their photo and passport number.'
}